/* @cap robe_native_variant_gallery | Two-product pilot: select already-rendered native Shopify variant media; no price, Globo, cart or zoom writes. */
(function () {
  'use strict';
  function start(configNode) {
    if (configNode.dataset.bound) return;
    configNode.dataset.bound = 'true';
    var config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    if (!['10735576678727', '16054518055242', '16055204282698', '16055204708682', '9990312689994', '9990322520394', '9990341427530', '9990202229066', '9990128140618', '10026364404042', '10026318725450', '10026354934090', '10026371940682', '10026369188170', '10026395763018', '10026292052298', '10026300473674', '10026321084746', '10026316104010', '10026390323530', '10026391208266', '16056629952842', '16056675729738', '16056678842698', '16056688509258', '10026358604106', '10026304962890', '10026374594890', '10026388062538', '10026408935754', '10026307813706', '10026312892746', '16054517629258', '10026381181258', '10026405560650', '10026400350538', '10026409820490', '16056899993930', '16056902975818', '16056903106890', '16056903205194', '9989969248586', '9598735581514', '9990027084106', '9990115688778', '9990161039690', '9990167101770', '9990212485450', '9990239813962', '9990045827402', '16056977883466', '16056983552330', '16056983748938', '16056983945546', '16056984568138', '16056985092426', '9990256853322', '10026337534282', '10026339991882', '10026375807306', '10164840005962', '10164907639114', '10165040808266', '16054550724938', '16056112513354', '16056143675722', '16056343527754', '16056431608138', '16059250082122', '16059231306058', '16059253260618', '16059255488842', '16059257585994', '16059261452618', '16059263746378'].includes(String(config.productId))) return;
    var product = document.getElementById('MainProduct-' + config.sectionId);
    if (!product || product.dataset.mbRobeGalleryBound || !config.variants) return;
    // The live template contains a hidden native picker and the custom picker with the same ID.
    var picker = product && Array.from(product.querySelectorAll('variant-selects')).find(function (node) { return node.querySelector('.custom-select'); });
    var gallery = document.getElementById('MediaGallery-' + config.sectionId);
    if (!picker || !gallery || typeof gallery.setActiveMedia !== 'function') return;
    var select = picker.querySelector('.custom-select');
    var variantInput = product && product.querySelector('.product-variant-id');
    if (!select || !variantInput) return;
    product.dataset.mbRobeGalleryBound = 'true';
    var sequence = 0;

    function showSelectedFront(media) {
      var fronts = new Set(Object.values(config.variants).filter(Boolean).map(String));
      (config.frontMediaIds || []).forEach(function (id) { fronts.add(String(id)); });
      if (config.cleanMediaId) fronts.add(String(config.cleanMediaId));
      function mark(element, id) {
        if (!fronts.has(String(id))) return;
        if (String(id) === String(media)) element.removeAttribute('data-mb-robe-hidden');
        else element.setAttribute('data-mb-robe-hidden', 'true');
      }
      gallery.querySelectorAll('[data-media-id]').forEach(function (element) {
        mark(element, element.dataset.mediaId.slice(config.sectionId.length + 1));
      });
      gallery.querySelectorAll('[data-target]').forEach(function (element) {
        mark(element, element.dataset.target.slice(config.sectionId.length + 1));
      });
      var modal = document.getElementById('ProductModal-' + config.sectionId);
      if (modal) modal.querySelectorAll('[data-media-id]').forEach(function (element) { mark(element, element.dataset.mediaId); });
      // Bild 5 "Tuch des gewaehlten Stoffs": nur das Tuchbild der gewaehlten Variante sichtbar (Bildmappe 24.09.2026).
      if (config.tuch) {
        var tuchSet = new Set((config.tuchMediaIds || []).map(String));
        var tuchWahl = String(config.tuch[String(variantInput.value)] || '');
        var markTuch = function (element, id) { if (!tuchSet.has(String(id))) return; if (String(id) === tuchWahl) element.removeAttribute('data-mb-robe-hidden'); else element.setAttribute('data-mb-robe-hidden', 'true'); };
        gallery.querySelectorAll('[data-media-id]').forEach(function (element) { markTuch(element, element.dataset.mediaId.slice(config.sectionId.length + 1)); });
        gallery.querySelectorAll('[data-target]').forEach(function (element) { markTuch(element, element.dataset.target.slice(config.sectionId.length + 1)); });
        if (modal) modal.querySelectorAll('[data-media-id]').forEach(function (element) { markTuch(element, element.dataset.mediaId); });
      }
      gallery.dataset.mbRobeEnhanced = 'true';
      if (modal) modal.dataset.mbRobeEnhanced = 'true';
      var chosenThumb = gallery.querySelector('[data-target="' + config.sectionId + '-' + media + '"]');
      if (chosenThumb) chosenThumb.parentNode.prepend(chosenThumb);
      if (gallery.elements && gallery.elements.thumbnails) gallery.elements.thumbnails.resetPages?.();
    }

    function syncViewerControls() {
      var viewer = gallery.elements && gallery.elements.viewer;
      if (!viewer || !viewer.slider) return;
      var controls = viewer.querySelector('.slider-buttons');
      if (!controls) return;
      var visible = Array.from(viewer.sliderItems || []).filter(function (item) { return item.clientWidth > 0; });
      if (visible.length === 1) {
        if (!controls.hasAttribute('data-mb-robe-single-medium')) {
          controls.dataset.mbRobePreviousDisplay = controls.style.display;
          controls.setAttribute('data-mb-robe-single-medium', 'true');
        }
        controls.style.display = 'none';
        viewer.sliderItemsToShow = visible;
        viewer.sliderItemOffset = viewer.slider.clientWidth || visible[0].clientWidth || 1;
        viewer.slidesPerPage = 1;
        viewer.currentPage = 1;
        viewer.totalPages = 1;
        if (viewer.currentPageElement) viewer.currentPageElement.textContent = '1';
        if (viewer.pageTotalElement) viewer.pageTotalElement.textContent = '1';
        if (viewer.prevButton) viewer.prevButton.disabled = true;
        if (viewer.nextButton) viewer.nextButton.disabled = true;
      } else {
        if (controls.hasAttribute('data-mb-robe-single-medium')) {
          controls.style.display = controls.dataset.mbRobePreviousDisplay || '';
          delete controls.dataset.mbRobePreviousDisplay;
          controls.removeAttribute('data-mb-robe-single-medium');
        }
        if (typeof viewer.resetPages === 'function') viewer.resetPages();
      }
    }

    function fail(id, code) {
      // A missing or failed brand image must never remove the original product photograph.
      var cleanKey = config.sectionId + '-' + config.cleanMediaId;
      var clean = gallery.querySelector('[data-media-id="' + cleanKey + '"]');
      var thumbs = gallery.elements && gallery.elements.thumbnails;
      if (clean && (!thumbs || thumbs.querySelector('[data-target="' + cleanKey + '"]'))) {
        showSelectedFront(config.cleanMediaId);
        gallery.setActiveMedia(cleanKey, true);
        syncViewerControls();
      }
      gallery.dispatchEvent(new CustomEvent('mb:robe-gallery-error', { bubbles: true, detail: { variantId: String(id), code: code } }));
      console.error('Robe gallery: ' + code + '; original photograph retained.');
    }

    var bbK6 = document.body && document.body.classList.contains('bb-t1--justiz');
    function showClean() {
      // Waehrend die Front des neuen Tuchs laedt: nie die Marke des vorigen Tuchs stehen lassen.
      if (!config.cleanMediaId) return;
      var cleanKey = config.sectionId + '-' + config.cleanMediaId;
      var clean = gallery.querySelector('[data-media-id="' + cleanKey + '"]');
      var thumbs = gallery.elements && gallery.elements.thumbnails;
      if (clean && (!thumbs || thumbs.querySelector('[data-target="' + cleanKey + '"]'))) {
        showSelectedFront(config.cleanMediaId);
        gallery.setActiveMedia(cleanKey, true);
      }
    }
    function waitDecode(image) {
      // Ohne Zeitlimit: die Front erscheint, sobald sie da ist (K6). Fehler bleiben Fehler.
      if (!image || /(?:no[-_]image|image[-_]not[-_]found|placeholder)/i.test(image.currentSrc || image.src)) return Promise.resolve(false);
      image.loading = 'eager';
      return image.decode().then(function () { return image.naturalWidth > 0 && image.naturalHeight > 0; }, function () {
        if (image.complete && image.naturalWidth > 0) return true;
        return new Promise(function (resolve) {
          image.addEventListener('load', function () { resolve(image.naturalWidth > 0); }, { once: true });
          image.addEventListener('error', function () { resolve(false); }, { once: true });
        });
      });
    }
    function preloadFronts() {
      // Nach dem ersten Bild die uebrigen Fronten leise vorladen (5 x 30-40 KB), damit der Stoffwechsel sofort sitzt.
      Object.values(config.variants).filter(Boolean).forEach(function (m) {
        var el = gallery.querySelector('[data-media-id="' + config.sectionId + '-' + m + '"] img');
        if (el && el.loading === 'lazy') el.loading = 'eager';
      });
    }
    async function imageReady(image) {
      if (!image || /(?:no[-_]image|image[-_]not[-_]found|placeholder)/i.test(image.currentSrc || image.src)) return false;
      image.loading = 'eager';
      var timer;
      try {
        await Promise.race([image.decode(), new Promise(function (_, reject) { timer = setTimeout(function () { reject(new Error('image timeout')); }, 10000); })]);
        return image.naturalWidth > 0 && image.naturalHeight > 0;
      } catch (_) { return false; }
      finally { clearTimeout(timer); }
    }

    function activate(id) {
      var stamp = ++sequence;
      queueMicrotask(async function () {
        if (stamp !== sequence || String(variantInput.value) !== String(id)) return;
        var media = config.variants[String(id)];
        if (!media) return fail(id, 'variant-media-unassigned');
        var mediaKey = config.sectionId + '-' + media;
        // Every allowed image and thumbnail must already exist: keeps native zoom bindings intact.
        var main = gallery.querySelector('[data-media-id="' + mediaKey + '"]');
        var thumbs = gallery.elements && gallery.elements.thumbnails;
        var thumb = thumbs && thumbs.querySelector('[data-target="' + mediaKey + '"]');
        if (!main || (thumbs && !thumb)) {
          return fail(id, 'native-media-missing');
        }
        var loaded;
        if (bbK6) {
          var waitImg = main.querySelector('img');
          var interim = setTimeout(function () { if (stamp === sequence && String(variantInput.value) === String(id)) showClean(); }, 1200);
          var slow = setTimeout(function () {
            if (stamp !== sequence) return;
            gallery.dispatchEvent(new CustomEvent('mb:robe-gallery-slow', { bubbles: true, detail: { variantId: String(id), mediaId: String(media) } }));
            console.warn('Robe gallery: brand image slower than 10 s; waiting, original photograph shown meanwhile.');
          }, 10000);
          loaded = await waitDecode(waitImg);
          clearTimeout(interim); clearTimeout(slow);
        } else {
          loaded = await imageReady(main.querySelector('img'));
        }
        if (stamp !== sequence || String(variantInput.value) !== String(id)) return;
        if (!loaded) return fail(id, 'brand-image-failed');
        showSelectedFront(media);
        gallery.setActiveMedia(mediaKey, true);
        syncViewerControls();
        gallery.dispatchEvent(new CustomEvent('mb:robe-gallery-ready', { bubbles: true, detail: { variantId: String(id), mediaId: String(media) } }));
      });
    }
    select.addEventListener('click', function (event) {
      var option = event.target.closest('.sme_option[data-value]');
      if (!option || !select.contains(option)) return;
      activate(option.dataset.value);
    });
    window.addEventListener('popstate', function () {
      var id = new URL(location.href).searchParams.get('variant') || String(config.defaultVariantId);
      if (!Object.prototype.hasOwnProperty.call(config.variants, id)) id = String(config.defaultVariantId);
      var option = select.querySelector('.sme_option[data-value="' + id + '"]');
      // Reuse the existing complete selector path (price, outer cloth, input). Do not create a second configuration model.
      if (option) option.dispatchEvent(new CustomEvent('click', { bubbles: true, detail: { mbHistoryRestore: true } }));
    });
    activate(variantInput.value);
    if (bbK6) (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(preloadFronts, { timeout: 4000 });
  }
  function boot() {
    customElements.whenDefined('media-gallery').then(function () {
      document.querySelectorAll('[data-mb-robe-gallery-config]').forEach(start);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();

/* >>> EG-NAHAUFNAHME 25.09.2026 v2 – Schild gegen die .media>*-Streckung des Themes gesichert (Şönem: „sicherstellen, dass der Kunde versteht, dass das eine Nahaufnahme ist“)
   Tuchbilder (Dateiname enthält „-tuchbild-“) tragen in der Galerie unten links und in jeder Vergrößerung unter dem Bild
   einen kleinen, feinen Hinweis „Tuch in Nahaufnahme · <Tuchname>“. Der Tuchname kommt aus dem vorhandenen Alt-Text.
   Vorschaubildchen bleiben ohne Hinweis. Für Screenreader sagt der Alt-Text es schon, der Hinweis ist aria-hidden.
   Wiederverwendete Bild-Elemente (Lightbox tauscht nur src) werden bei jedem Wechsel neu bewertet. */
(function () {
  if (window.__egNahaufnahme) return; window.__egNahaufnahme = true;
  var EN = /robe-shop\.com$/.test(location.hostname) || (document.documentElement.lang || '').slice(0, 2) === 'en';
  var WORT = EN ? 'Cloth close-up' : 'Tuch in Nahaufnahme';
  var css = document.createElement('style');
  css.textContent =
    '.eg-nah{pointer-events:none;font-size:11px;line-height:1.3;font-weight:500;letter-spacing:.06em;color:#1d1d1f;' +
    'background:rgba(255,255,255,.9);padding:5px 9px;border-radius:2px;max-width:calc(100% - 24px);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.eg-nah--bild,.media>.eg-nah.eg-nah--bild,.product__media>.eg-nah.eg-nah--bild{position:absolute!important;top:auto!important;right:auto!important;left:12px!important;bottom:12px!important;width:auto!important;height:auto!important;max-width:calc(100% - 24px)!important;display:inline-block!important;z-index:2}' +
    '.eg-nah--unter{display:block;position:static;margin:10px auto 0;width:max-content;max-width:90%;background:transparent;color:rgba(255,255,255,.86);text-align:center}' +
    '.product-media-modal .eg-nah--unter{color:#3a362f}';
  document.head.appendChild(css);
  function datei(i) { return ((i.currentSrc || i.getAttribute('src') || '').split('?')[0].split('/').pop() || '').replace(/_\d+x\d*(?=\.)/, ''); }
  function gut(a) { return /nahaufnahme|close-up|tuch|cloth/i.test(a || ''); }
  function vorn(a) { var n = (a || '').trim().split(/\s[–—-]\s|,\s/)[0]; return n && n.length < 60 ? n : ''; }
  function name(img) {
    var a = img.getAttribute('alt') || '';
    if (gut(a)) return vorn(a);
    var f = datei(img), andere = Array.prototype.find.call(document.images, function (i) { return i !== img && datei(i) === f && gut(i.getAttribute('alt')); });
    return andere ? vorn(andere.getAttribute('alt')) : '';
  }
  function markieren(img) {
    var src = img.currentSrc || img.getAttribute('src') || '';
    var ist = /-tuchbild-/.test(src) && !img.closest('.thumbnail, .thumbnail-list, button');
    var el = img.__egNahEl;
    if (!ist) { if (el) { el.remove(); img.__egNahEl = null; } return; }
    var t = WORT + (name(img) ? ' · ' + name(img) : '');
    if (el) { if (el.textContent !== t) el.textContent = t; return; }
    var s = document.createElement('span'); s.setAttribute('aria-hidden', 'true'); s.textContent = t;
    var galerie = img.closest('.product__media, .product__media-item');
    if (galerie && !img.closest('.product-media-modal, [class*="lightbox"], dialog')) {
      var box = img.closest('.product__media') || img.parentElement;
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      s.className = 'eg-nah eg-nah--bild'; box.appendChild(s);
    } else {
      s.className = 'eg-nah eg-nah--unter'; img.insertAdjacentElement('afterend', s);
    }
    img.__egNahEl = s;
  }
  function alle(root) { root.querySelectorAll('img').forEach(markieren); }
  function start() {
    alle(document);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'attributes') { if (m.target.tagName === 'IMG') markieren(m.target); return; }
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.tagName === 'IMG') markieren(n); else alle(n); } });
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'alt'] });
    document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') markieren(e.target); }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
/* <<< EG-NAHAUFNAHME */

